"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeeMore = void 0;
const react_1 = __importStar(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const caret_1 = require("../caret");
const styles_1 = require("./styles");
const SeeMore = (props) => {
    const { seeMoreCopy = 'See More', seeLessCopy = 'See Less', showOnDesktop = false, maxHeight, linkColor, fadeColor, fadeHeight } = props;
    const [seeMore, setSeeMore] = (0, react_1.useState)(true);
    const [rect, ref] = (0, monera_app_core_1.useClientRect)();
    const maxHeightNumber = maxHeight ? parseInt(maxHeight) : 9999;
    const actualHeightNumber = rect ? rect.height : 0;
    const seeMoreEnabled = (maxHeight !== undefined || showOnDesktop) && actualHeightNumber > maxHeightNumber;
    const seeMoreOrLess = (react_1.default.createElement(styles_1.StyledSeeMoreLinkContainer, null,
        seeMore && react_1.default.createElement(styles_1.StyledContentFader, { fadeColor: fadeColor, fadeHeight: fadeHeight }),
        react_1.default.createElement(styles_1.StyledSeeMoreLink, { linkColor: linkColor, onClick: () => setSeeMore(!seeMore) },
            react_1.default.createElement(caret_1.Caret, { linkColor: linkColor, rotation: !seeMore ? caret_1.CaretDirection.Up : undefined, size: caret_1.CaretSize.Small }),
            seeMore ? seeMoreCopy : seeLessCopy)));
    return (react_1.default.createElement(styles_1.StyledSeeMoreContainer, null,
        react_1.default.createElement(styles_1.StyledSeeMoreContentContainer, Object.assign({ ref: ref }, props, { seeMoreEnabled: seeMoreEnabled, collapsed: seeMore }),
            props.children,
            seeMoreEnabled && seeMoreOrLess)));
};
exports.SeeMore = SeeMore;
